import type { DeliveryAreaConfig } from "@/lib/delivery-area/types"
import { atom } from "jotai"

/**
 * Source of truth for how the store delivers (POLYGON vs NEIGHBORHOOD, and its
 * served cities/neighborhoods). `null` until the first read resolves and
 * whenever the endpoint is unavailable — `service-area.ts` then falls back to
 * the catalog's drawn polygon only, never guessing at neighborhood coverage.
 */
export const deliveryAreaConfigAtom = atom<DeliveryAreaConfig | null>(null)

export default deliveryAreaConfigAtom
